import "lazysizes";
import "@/style/pc/common.scss";
import "./training.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

gsap.registerPlugin(ScrollTrigger);

gsap.to(".pc-header", {
  backgroundColor: "#fff",
  height: WindowWidth < 903 ? "70px" : "80px",
  borderBottom: "1px solid #efefef",
  scrollTrigger: {
    trigger: ".training-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.to(".pc-header .logo", {
  width: "144px",
  height: "58px",
  scrollTrigger: {
    trigger: ".training-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.fromTo(".us-phone, nav .color-f, .us-phone .phone-number, .us-phone .phone-desc",
  { color: "#fff" },
  { color: "#1B451D",
  scrollTrigger: {
    trigger: ".training-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.to(".logo-img-white", {
  opacity: 0,
  scrollTrigger: {
    trigger: ".training-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

document
  .querySelector(".mobile-menu-btn")
  .addEventListener("click", function () {
    document.querySelector(".mobile-header-nav").classList.add("block");
  });
document
  .querySelector(".mobile-header-nav-close")
  .addEventListener("click", function (e) {
    document.querySelector(".mobile-header-nav").classList.remove("block");
    e.stopPropagation();
    e.preventDefault();
  });

// 移动端下拉菜单交互
document.querySelectorAll('.mobile-nav-parent').forEach(function(parent) {
  parent.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const dropdown = this.parentElement;
    const submenu = dropdown.querySelector('.mobile-submenu');
    const arrow = this.querySelector('.dropdown-arrow');
    
    // 切换当前菜单
    this.classList.toggle('active');
    submenu.classList.toggle('show');
  });
});

var WindowWidth = 0;
function updateScreenSize() {
  WindowWidth = document.documentElement.clientWidth;
}
updateScreenSize();
window.addEventListener("resize", updateScreenSize);

// 核心教学内容卡片展开/收起
(function () {
  document.querySelectorAll('.training-core-card').forEach(function (card) {
    card.addEventListener('click', function (e) {
      // 手机端(≤600px): 点击整张卡片展开/收起
      if (window.innerWidth <= 600) {
        this.classList.toggle('active');
        return;
      }
      // iPad/PC: 只有点击"查看更多"才触发
      var moreBtn = e.target.closest('.training-core-card-more');
      if (moreBtn) {
        e.preventDefault();
        this.classList.toggle('active');
      }
    });
  });
})();

// 全套核心教学内容 Swiper
(function () {
  const wrap = document.querySelector(".training-core-swiper-wrap");
  const container = wrap ? wrap.querySelector(".training-core-swiper") : null;
  if (!container) return;

  const coreSwiper = new Swiper(container, {
    slidesPerView: 1,
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: wrap.querySelector(".swiper-pagination"),
      clickable: true,
    },
  });

  // 多条件协同自动轮播控制
  let isHovered = false;
  let isVisible = true;

  function updateAutoplay() {
    if (!isHovered && isVisible) {
      coreSwiper.autoplay.start();
    } else {
      coreSwiper.autoplay.stop();
    }
  }

  // hover 暂停/恢复
  wrap.addEventListener("mouseenter", () => {
    isHovered = true;
    updateAutoplay();
  });
  wrap.addEventListener("mouseleave", () => {
    isHovered = false;
    updateAutoplay();
  });

  // Intersection Observer 可视区域检测
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isVisible = entry.isIntersecting;
        updateAutoplay();
      });
    },
    { threshold: 0 }
  );
  observer.observe(container);
})();
